const beforeYouGoEndpoints = {
  base: "/v1/cms/before-you-go",
  byTour: (tourId) => `/v1/cms/before-you-go/${encodeURIComponent(String(tourId || ""))}`,
};

export default beforeYouGoEndpoints;
